import { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { validateAuthToken } from '../services/authService';
import { clearAuthSession, isAuthenticated } from '../storage/authStorage';

export default function PrivateRoute({ children }) {
  const hasToken = isAuthenticated();
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    if (!hasToken) return undefined;

    let cancelled = false;

    validateAuthToken()
      .then(() => {
        if (!cancelled) setIsValid(true);
      })
      .catch(() => {
        if (!cancelled) {
          clearAuthSession();
          setIsValid(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [hasToken]);

  if (!hasToken) {
    return <Navigate to="/" replace />;
  }

  if (isValid === null) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <CircularProgress sx={{ color: '#ff00f2' }} />
      </Box>
    );
  }

  if (!isValid) {
    return <Navigate to="/" replace />;
  }

  return children;
}
